import jQuery from 'jquery';
import Drupal from 'drupal';
import once from "once";

(function initContactFinder(this: any, $: JQueryStatic<HTMLElement>) {
    class ContactManager {
        $wrapper: JQuery<HTMLElement>;

        $container: JQuery;

        $row: JQuery;

        elements: JQuery<HTMLElement>;

        $needs: JQuery<HTMLElement>;

        contactFinder: JQuery<HTMLElement>;

        $accordionButton: JQuery<HTMLElement>;

        $accordionButtonExpanded: JQuery<HTMLElement>;

        contactTable: JQuery<HTMLElement>;

        $allRows: JQuery<HTMLElement>;

        $backTo: JQuery<HTMLElement>;

        needsLoaded = false;

        observer: MutationObserver;

        static contactManager: ContactManager[] = [];

        /**
         * @param {HTMLElement} contactManager
         * @param contactManager
         * A DOM element.
         */
        constructor(contactManager: Element) {

            /**
             * @type {jQuery}
             */
            this.$container = $(contactManager);

            /**
             * @type {jQuery}
             */
            this.$wrapper = this.$container.closest('.c-contact-table-wrapper');

            /**
             * @type {any}
             */
            this.contactTable = this.$container;

            /**
             * @type {jQuery}
             */

            this.$row = this.contactTable.find('.c-contact-row__wrapper');

            /**
             * @type {jQuery}
             */
            this.contactFinder = this.$wrapper.find('.contact-finder');

            /*
            * @type {any}
             */
            this.$needs = this.contactFinder.find('li');

            /**
             * @type {any}
             */
            this.elements = this.$needs.find('a');


            /**
             * @type {jQuery}
             */
            this.$accordionButton = this.$wrapper.find('.usa-accordion__button');
            this.$accordionButtonExpanded = this.contactFinder.find('.usa-accordion__button[aria-expanded="true"]');

            /**
             * @type {jQuery}
             */
            this.$allRows = this.$wrapper.find('.c-contact-table .c-contact-table-body .c-contact-row__wrapper');
            /**
             * @type {jQuery}
             */
            this.$backTo = this.$wrapper.find('.c-contact-table__back-to');

            /**
             * @type {jQuery}
             */
            this.$backTo.addClass('hidden');

            this.setupEventListeners();
            // Add event listener for need links
            this.$container.find('.need-link').on('click', this.handleNeedClick.bind(this));


            // Add class to .contact-finder-accordion .usa-accordion__content.
            this.$container.addClass('processed');

            this.observer = new MutationObserver(() => this.handleAccordionButtonExpanded());
            // Observe changes in the attributes of the accordion button if it exists.
            if (this.$accordionButton.length) {
                this.observer.observe(this.$accordionButton[0], {attributes: true});
            }

            // Call the function to filter on page load.
            this.filterContactSectionByURL();

            // Call the function to handle the contact row addition.
            this.handleContactRowAddition();

            // Call the function to remove specified class.
            this.removeDualCategoryClass();

        }

        setupEventListeners() {
            this.elements.each((_, element: HTMLElement) => {
                element.addEventListener('click', this.handleNeedClick.bind(this));
            });
            this.$backTo.each((_, element: HTMLElement) => {
                element.addEventListener('click', this.backToContactFinder.bind(this));
            });

            this.$needs.each((_, element: HTMLElement) => {
                element.addEventListener('mouseenter', this.handleNeedMouseEnter.bind(this));
                element.addEventListener('mouseleave', this.handleNeedMouseLeave.bind(this));
            });
        }

        removeDualCategoryClass() {
            const contactRowWrapper = this.$wrapper.find('.c-contact-row__wrapper');
            const heading = contactRowWrapper.find('.c-contact-row__heading.title-only');

            if (heading.length == 0) {
                const contactGroup = this.$wrapper.find('.c-contact-group.c-contact-group__dual-category');
                contactGroup.removeClass('c-contact-group__dual-category');
            }
        }

        handleNeedClick(event) {
            event.preventDefault();
            const selectedNeed = event.target.textContent;

            // Call the function to filter and display the matching rows based on the selected need
            this.filterRowsByNeed(selectedNeed);

            // Generate the filtered URL based on the selected need.
            this.generateFilteredURL(selectedNeed);

            // Find the relevant table container
            const clickedContainer = $(event.target).closest('.c-contact-table-wrapper');

            // Scroll to top of the table container
            if (clickedContainer && clickedContainer.length > 0) {
                let containerTop = clickedContainer.offset()?.top;
                if (containerTop !== undefined) {
                    containerTop -= 160; // Subtract 30px to provide additional space
                    $('html, body').animate({
                        scrollTop: containerTop
                    }, 'slow');
                }
            }
        }


        handleNeedMouseEnter() {
            const accordionHeadings = $('.usa-accordion__heading');

            accordionHeadings.removeClass('expanded');
            accordionHeadings.addClass('hovered');
        }

        handleNeedMouseLeave() {
            const accordionHeadings = $('.usa-accordion__heading');

            accordionHeadings.addClass('expanded');
            accordionHeadings.removeClass('hovered');
        }

        handleAccordionButtonExpanded() {
            const expanded = this.$accordionButton.attr('aria-expanded') === 'true';

            if (expanded) {
                const accordionHeadings = $('.usa-accordion__heading');
                const accordionContent = $('.usa-accordion__content');
                accordionHeadings.addClass('expanded');
                accordionContent.removeClass('hidden');
            } else {
                const accordionHeadings = $('.usa-accordion__heading');
                accordionHeadings.removeClass('expanded');
            }
        }

        generateFilteredURL(selectedNeed) {
            const currentURL = new URL(window.location.href);

            // Remove any existing filter query parameters
            currentURL.searchParams.delete('filter');

            // Add the new filter as a query parameter
            currentURL.searchParams.append('filter', selectedNeed);

            // Update hreflang attributes for filtered URL
            if ((window as any).aphisHreflangManager) {
                (window as any).aphisHreflangManager.updateHreflangForFilteredURL(currentURL.href);
            }

            // Replace the current URL with the updated one
            window.history.replaceState({}, document.title, currentURL.href);
        }

        getRowNeeds(row) {
            const rowNeeds = $(row).data('needs');
            return typeof rowNeeds === 'string' ? rowNeeds.split('|').map((item) => item.trim()) : [];
        }
        
        isRowNeedsValid(rowNeeds) {
            return Array.isArray(rowNeeds) && rowNeeds.length > 0;
        }

        handleSelectedNeed(row, selectedNeed) {
            this.contactFinder.addClass('hidden');
        
            const {contactTable} = this;
            if (contactTable && !contactTable.find('.c-contact-table__title').length) {
                if (contactTable.find('.c-contact-table-body').data('hide-text') == 1) {
                    contactTable.prepend(`<p class="c-contact-table__title">${selectedNeed}</p>`);
                } else {
                    contactTable.prepend(`<p class="c-contact-table__title">To ${selectedNeed}, contact:</p>`);
                }
            }
        
            const backTo = contactTable?.next();
            backTo?.removeClass('hidden');
        }

        filterContactSectionByURL() {
            if (!window.location.search) {
                return;
            }
        
            const urlSearchParams = new URLSearchParams(window.location.search);
            const selectedNeed = urlSearchParams.get('filter');

            if (selectedNeed === null) {
                return;
            }
        
            this.$container.each((index, section) => {
                const rows = $(section).find('.c-contact-row__wrapper');
        
                const sectionIncludesSelectedNeed = rows.toArray().some((row) => {
                    const rowNeeds = this.getRowNeeds(row);
                    return this.isRowNeedsValid(rowNeeds) && rowNeeds.includes(selectedNeed);
                });
        
                if (!sectionIncludesSelectedNeed) {
                    return;
                }
        
                rows.each((_index, row) => {
                    const rowNeeds = this.getRowNeeds(row);
        
                    if (this.isRowNeedsValid(rowNeeds) && rowNeeds.includes(selectedNeed)) {
                        this.handleSelectedNeed(row, selectedNeed);
                    } else {
                        $(row).hide();
                    }
                });
            });
        }

        filterRowsByNeed(selectedNeed) {
            this.$container.each((index, section) => {
                const rows = $(section).find('.c-contact-row__wrapper');

                const sectionIncludesSelectedNeed = rows.toArray().some((row) => {
                    const rowNeeds = $(row).data('needs');
                    return typeof rowNeeds === 'string' ? rowNeeds.split('|').map(item => item.trim()).includes(selectedNeed) : false;
                });

                if (!sectionIncludesSelectedNeed) {
                    return;
                }

                rows.each((_index, row) => {
                    const rowNeeds = $(row).data('needs');
                    const needsArray = typeof rowNeeds === 'string' ? rowNeeds.split('|').map(item => item.trim()) : [];

                    if (Array.isArray(needsArray) && needsArray.includes(selectedNeed)) {
                        this.handleSelectedNeed(row, selectedNeed);
                    } else {
                        $(row).hide();
                    }
                });
            });
        }

        backToContactFinder(event) {
            event.preventDefault();
            this.contactFinder.removeClass('hidden');
            this.$allRows.removeClass('hidden');
            this.$allRows.show();
            this.contactTable.find('.c-contact-table__title').remove();
            this.$backTo.addClass('hidden');
            // Remove the filter query parameter from the URL
            const currentURL = new URL(window.location.href);
            currentURL.searchParams.delete('filter');
            window.history.replaceState({}, document.title, currentURL.href);
            // Collapse the accordion
            this.$accordionButton.attr('aria-expanded', 'false');
            // Add the hidden class to the accordion content.
            const accordionContent = $('.usa-accordion__content');
            accordionContent.addClass('hidden');
        }

        handleContactRowAddition() {
            $(document).ajaxComplete(() => {
                $(".ui-dialog").each((_, element) => {
                    if ($(element).find(".ui-dialog-title").text() === "Create new Contact Section Row" || $(element).find(".ui-dialog-title").text() === "Edit Contact Section Row") {

                        const $input = $(element).find('select[name="field_select_contact_type"]');
                        const $fieldContactGroup = $(element).find('.field--name-field-contact-group-ref');
                        const $fieldContactItem = $(element).find('.field--name-field-contact-item-ref');

                        // Initial visibility
                        $fieldContactGroup.toggle($input.val() === 'group');
                        $fieldContactItem.toggle($input.val() === 'item');

                        // Change visibility on input change
                        $(document).on('change', 'select[name="field_select_contact_type"]', function (this: HTMLElement) {
                            const val = $(this).val();
                            $fieldContactGroup.toggle(val === 'group');
                            $fieldContactItem.toggle(val === 'item');
                        });
                    }
                });
            });
        }
    }

    // Expose constructor in the public space.
    Drupal.ContactManager = ContactManager;

    /**
     * Process elements with the .usa-accordion__content class on page load.
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~contactManager} attach
     *  Attaches contactManager behavior to relevant elements.
     */
    Drupal.behaviors.contactManager = {
        attach(context, settings) {
            const contactManager = once('contactManager', '.c-contact-table', context);
            if (contactManager.length) {
                const cm = contactManager.length;
                for (let i = 0; i < cm; i += 1) {
                    ContactManager.contactManager.push(new ContactManager(contactManager[i]));
                }
            }
        }
    };

})(jQuery);
